
import { EmpresaFormComponent } from './empresa-form/empresa-form.component';
import { ImportacionFacturasMasivasComponent } from './importacion-facturas-masivas/importacion-facturas-masivas.component';

const routes = [
	{
		path: 'importacion-facturas-masivas',
		component: ImportacionFacturasMasivasComponent,
	},
	{
		path: 'bussines',
		component: EmpresaFormComponent,
	},
];

export const ViewsRoutes = routes;
